import React from 'react';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const ActionBanner = ({ actionBanner, popupRef, handleClick, amplitudePaymentMethodEvent, method }) => {
    const { continueTransferFlow, changePaymentOption } = usePageMessages();
    return (
        <SimplePopup popupRef={popupRef} text={<DangerouslyHtml dangerouslyHtml={actionBanner} />}>
            <PopupButton
                iconName="arrow-forward"
                text={continueTransferFlow}
                onClick={() => {
                    popupRef.current?.close();
                    amplitudePaymentMethodEvent?.(method);
                    handleClick();
                }}
            />
            <PopupButton
                iconName="retry"
                text={changePaymentOption}
                onClick={() => {
                    popupRef.current?.close();
                }}
            />
        </SimplePopup>
    );
};
ActionBanner.propTypes = {
    actionBanner: PropTypes.string,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    handleClick: PropTypes.func,
    amplitudePaymentMethodEvent: PropTypes.func,
};
export default ActionBanner;
